import React from 'react'
import { Modal } from 'components/Modal'
import { ContactUs } from './components/ContactUs'

interface Props {
  showForm: boolean
  type: 'resident_contact' | 'community_contact'
  setShowForm: (param: boolean) => void
}

export const ContactForm = ({ showForm, type, setShowForm }: Props) => {
  return (
    <Modal
      isOpen={showForm}
      modalTitle='Contact Us'
      handleCloseModal={() => setShowForm(false)}
      type='normal'
    >
      <div>
        <ContactUs
          setIsModalOpen={setShowForm}
          contactType={type}
        />
      </div>
    </Modal>
  )
}
